import { __decorate, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import template from './btpg-steps-counter.component.html';
var BtpgStepsCounterComponent = (function () {
    function BtpgStepsCounterComponent() {
        this.current = 0;
        this.total = 0;
    }
    Object.defineProperty(BtpgStepsCounterComponent.prototype, "message", {
        get: function () {
            var _a;
            return ((_a = this.messageTemplate) === null || _a === void 0 ? void 0 : _a.replace("[current]", "" + this.current).replace("[total]", "" + this.total)) || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BtpgStepsCounterComponent.prototype, "visible", {
        get: function () {
            return Boolean(this.current && this.total && this.messageTemplate);
        },
        enumerable: false,
        configurable: true
    });
    BtpgStepsCounterComponent.$inject = [];
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], BtpgStepsCounterComponent.prototype, "messageTemplate", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], BtpgStepsCounterComponent.prototype, "current", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], BtpgStepsCounterComponent.prototype, "total", void 0);
    BtpgStepsCounterComponent = __decorate([
        Component({
            selector: 'btpgStepsCounter',
            template: template,
        })
    ], BtpgStepsCounterComponent);
    return BtpgStepsCounterComponent;
}());
export { BtpgStepsCounterComponent };
